import module from '../module';
import scopeUtil from '../../../utils/scope';
import * as _ from 'lodash';

class CategoryHeaderDirectiveController {
    static $inject = ['$scope', 'CatalogService', 'Message', '$rootScope'];

    constructor(scope, catalogService, messageService, rootScope) {

        this._scope = scope;
        this._rootScope = rootScope;
        this._catalogService = catalogService;
        this._messageService = messageService;

        scope.searchInProgress = false;
        scope.categoryName = "";
        scope.categoryId = 0;
        rootScope.categoryId = 0;
        scope.categories = [];
        rootScope.searchString = "";

        scope.clearSearch = () => this._clearSearch();

        scope.$watch('categoryId', categoryId => {
            rootScope.categoryId = categoryId;
            const category = _.find(scope.categories, {id: parseInt(categoryId)});
            scope.categoryName = category ? category.name : '';
        });
    }

    async $onInit() {
        await this._loadCategories();
        scopeUtil.apply(this._scope);
    }

    _clearSearch() {
        this._scope.searchInProgress = false;
        this._scope.searchString = '';
    }

    async _loadCategories() {
        try {
            this._scope.categories = await this._catalogService.getAllCategories();
            this._scope.categoryName = await this._catalogService.getDefaultCategory();
            const category = _.find(this._scope.categories, {name: this._scope.categoryName});
            this._scope.categoryId = category ? category.id : this._scope.categories[0].id;
        } catch (error) {
            this._messageService.showErrorPopupForResponse(error);
        }
    }
}

module.directive('categoryHeader', function () {
    return {
        scope: true,
        templateUrl: 'modules/shared/views/categoryHeader.html',
        controller: CategoryHeaderDirectiveController
    };
});



// WEBPACK FOOTER //
// ./src/modules/shared/directives/CategoryHeaderDirective.js